export enum ATTENDANCE {
  ENTRY = 'ENTRY',
  EXIT = 'EXIT',
}
